import { useEffect, useState } from "react";
import CustomValuesHook from "../../../../Hooks/customValuesHook";
import { IData } from "../../../../api/modelAPI/detectedSensitiveWordLog";
import { PlaySVG, StopSVG } from "../../../../assets/images/svg/icon";
import { ErrorToast } from "../../../../shared";
import { getUrlLink } from "../../../../api/requestAxios/getDetectedSensitiveWordLog";

type Props = {
  item: IData;
  index: number;
  url: string;
};

const VoiceFile = ({ item, index, url }: Props) => {
  const [msg, setMsg] = CustomValuesHook({
    getS3UrlResult: "",
    loadingPlay: false,
    loadingDownload: "",
    indexLoading: "",
    _item: {},
  });

  useEffect(() => {
    let obj = msg._item;
    obj.isPlay = false;
    obj.isDownload = false;
    obj.index = index;
    setMsg({ _item: obj });
  }, [item]);

  const getUrl = async (url: string, from: string, index: number) => {
    if (from === "play") {
      setMsg({
        loadingPlay: true,
        loadingDownload: false,
        indexLoading: index,
      });
    } else {
      setMsg({
        loadingPlay: false,
        loadingDownload: true,
        indexLoading: index,
      });
    }
    try {
      const response = await getUrlLink(url);
      setMsg({ loadingPlay: false, loadingDownload: false });
      setMsg({ getS3UrlResult: response?.data?.Url });
      if (from === "download") {
        downloadFileFn(response?.data?.Url);
      }
    } catch (error) {
      setMsg({ loadingPlay: false, loadingDownload: false });
      ErrorToast(error);
    }
  };

  const setPaly = (e: any, index: number) => {
    e.preventDefault();
    if (msg?._item?.index === index) {
      let obj = msg._item;
      obj.isPlay = !obj?.isPlay;
      setMsg({ _item: obj });
      if (obj?.isPlay) getUrl(url, "play", index);
    }
  };

  const endPlay = () => {
    let obj = msg._item;
    obj.isPlay = false;
    setMsg({ _item: obj });
  };

  const download = (e: any, id: string, index: number) => {
    if (msg?._item.index === index && id === item?.id) {
      let obj = msg._item;
      obj.isDownload = true;
      setMsg({ _item: obj });
      getUrl(url, "download", index);
    }
  };

  const downloadFileFn = (url: string) => {
    const a = document.createElement("a");
    a.download = "test.wav";
    a.href = url;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
  };

  return (
    <div className="d-flex flex-column justify-content-start align-items-start voice-file">
      <label>فایل صوتی: </label>

      <div className="d-flex justify-content-between align-items-center paly-stop-wrapper">
        {!msg?.loadingPlay && (
          <span
            onClick={(e) => {
              setPaly(e, msg?._item?.index);
            }}
          >
            {!msg?._item?.isPlay ? <PlaySVG /> : <StopSVG />}
          </span>
        )}
        {msg?.loadingPlay && (
          <div
            className="spinner-border"
            role="status"
            aria-hidden="true"
          ></div>
        )}

        {msg?._item?.isPlay && (
          <audio src={msg?.getS3UrlResult} autoPlay onEnded={endPlay} />
        )}

        <div
          className="download-section"
          onClick={(e) => {
            download(e, item?.id, index);
          }}
        >
          {msg?.loadingDownload ? (
            <div
              className="spinner-border"
              role="status"
              aria-hidden="true"
            ></div>
          ) : (
            <span className="download-btn">دانلود فایل</span>
          )}
        </div>
      </div>
    </div>
  );
};
export default VoiceFile;
